export default "__VITE_ASSET__DLRQDJO1__"